import { FC, useEffect } from "react";
import Layout, { SetActionsLayout } from "../../layout/Layout";
import { State } from "../../../redux/slices";
import { useDispatch, useSelector } from "react-redux";
import NotFound from "../../NotFound";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Modal, Snackbar } from "@mui/material";
import { ThunkDispatch } from "@reduxjs/toolkit";
import AddIcon from "@mui/icons-material/Add";
import { BinCard } from "./binDesignCard";
import { LoadingCircularProgress } from "../../Loading";
import SelectedBin from "./selectedBin";
import {
  setAllotmentPolicies,
  setEditionValues,
  setLocationGrainTracker,
  setPrincipalInfoGT,
  setPrincipalInfoGTCopy,
  setTheBinIsGood,
  setValuesEditLocation,
} from "../../../redux/slices/grainTracker/grainTrackerEdition";

import {
  LocationGrainTrackerValues,
  PrincipalInfoGT,
  SelectedLocation,
} from "../../../redux/slices/grainTracker/grainTrackerTypes";

import { BodyLoadingModal } from "./loadingModal";
import { LocationSelectedDetails } from "../../../redux/actions/locations/locationsTypes";

import {
  fetchSiteInformation,
  fetchStoragesOfEachLocationLocationView,
  resetBinStorage,
} from "../../../redux/actions/locations/locationDetailsAsync";
import {
  resetStateShareSite,
  setSelectedSiteToShare,
} from "../../../redux/slices/shareSite/shareSite";
import {
  resetSingleLocation,
  setIfBinIsSelected,
} from "../../../redux/slices/location/singleLocation";

import LocationDetailsMenu from "./locationDetailsParts/locationDetailsMenus";
import { CheckExpiredToken } from "../../../utils/authentication";
import { theBinIsGood } from "../../grainWise/create/GrainTrackerForm";
import { fetchQualityCriteria } from "../../../redux/actions/GrainWise/grainwiseEditionServices/grainTrackerGetServicesEdition";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  return {
    fetchStoragesOfEachLocation: (token: string, orgGeoPointId: number) => {
      dispatch(
        fetchStoragesOfEachLocationLocationView({ token, orgGeoPointId }),
      );
      dispatch(fetchSiteInformation({ token, orgGeoPointId }));

      dispatch(
        setEditionValues({ EditingStockage: true, EditingValues: false }),
      );
    },
    redirectToEditLocation: (
      selectedLocation: SelectedLocation,
      navigate: any,
      locationSelectedIs: { EditingValues: boolean },
    ) => {
      dispatch(setValuesEditLocation(selectedLocation));
      dispatch(
        setEditionValues({ ...locationSelectedIs, EditingValues: true }),
      );
      setTimeout(() => {
        navigate(`/site/edit/${selectedLocation.values.id}`);
      }, 300);
    },

    setLocationGrainTracker: (
      graintrackerValues: LocationGrainTrackerValues,
    ) => {
      dispatch(setLocationGrainTracker(graintrackerValues));
    },

    setSelectedSiteToShare: (
      navigate: any,
      selectedSiteToShare: { name: string; id: string },
    ) => {
      dispatch(setSelectedSiteToShare(selectedSiteToShare));
      navigate(`/site/share/${selectedSiteToShare.name}`);
    },

    redirectToEditStorage: (
      selectedLocation: LocationSelectedDetails,
      navigate: any,
      locationSelectedIs: { EditingStockage: boolean },
      graintrackerValues: LocationGrainTrackerValues,
    ) => {
      const createFormat = {
        id: selectedLocation.id,
        name: selectedLocation.name,
        longitude: selectedLocation.longitude,
        latitude: selectedLocation.latitude,
        address: selectedLocation.address,
        totalCapacity: selectedLocation.totalCapacity,
        values: selectedLocation,
      };
      dispatch(setValuesEditLocation(createFormat));
      dispatch(
        setEditionValues({ ...locationSelectedIs, EditingStockage: true }),
      );
      dispatch(
        setLocationGrainTracker({
          ...graintrackerValues,
          locationInformation: selectedLocation,
        }),
      );

      setTimeout(() => {
        navigate(`/site/edit/storage/${createFormat.id}`);
      }, 300);
    },

    setInformationByClicking: (
      binInformation: any,
      principalInfoGT: PrincipalInfoGT,
      principalInfoGTCopy: PrincipalInfoGT,
      token: string,
    ) => {
      if (!binInformation) {
        return;
      }

      dispatch(
        setTheBinIsGood(
          !theBinIsGood(
            binInformation?.cerealTypeId || null,
            binInformation?.storageTemplateId || null,
            binInformation?.totalCapacity?.value || 0,
          ),
        ),
      );

      dispatch(
        setPrincipalInfoGT({
          ...principalInfoGT,
          name: binInformation?.name || "",
          specie: binInformation?.cerealTypeId || null,
          storage: binInformation?.storageTemplateId || null,
          currentCharacteristics: binInformation?.currentCharacteristics || [],
          allotmentPolicies: binInformation?.allotmentPolicies || [],
          tonsCapacity:
            binInformation?.characteristics?.capacityMetricTonsWheatEq || 0,
          id: binInformation?.id || null,
        }),
      );

      dispatch(
        setPrincipalInfoGTCopy({
          ...principalInfoGTCopy,
          name: binInformation?.name || "",
          specie: binInformation?.cerealTypeId || null,
          currentCharacteristics: binInformation?.currentCharacteristics || [],
          storage: binInformation?.storageTemplateId || null,
          allotmentPolicies: binInformation?.allotmentPolicies || [],
          tonsCapacity:
            binInformation?.characteristics?.capacityMetricTonsWheatEq || 0,
          id: binInformation?.id || null,
        }),
      );

      dispatch(setAllotmentPolicies([]));

      setTimeout(() => {
        dispatch(setAllotmentPolicies(binInformation?.allotmentPolicies || []));
      }, 300);

      if (binInformation?.cerealTypeId) {
        dispatch(
          fetchQualityCriteria({ token, specie: binInformation.cerealTypeId }),
        );
      }
    },

    resetBin: () => {
      dispatch(setIfBinIsSelected(false));
    },

    resetStateShareSite: () => {
      dispatch(resetStateShareSite());
    },

    resetStorage: (storageInstanceUUID: string) => {
      dispatch(resetBinStorage({ storageInstanceUUID }));
    },
    resetSingleLocationState: () => {
      dispatch(resetSingleLocation());
    },
  };
};

const errors = (fetchSelectedBinInformation: string) => {
  return (
    <div className="errors-selected-bin-show">
      {fetchSelectedBinInformation ? (
        <Alert severity="error">{fetchSelectedBinInformation}</Alert>
      ) : (
        ""
      )}
    </div>
  );
};
const filters = () => {
  return <div className="filters-loc-detail"></div>;
};

const LocationDetails: FC = () => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const { user, isViewerOnly } = useSelector(
    (state: State) => state.Authentication,
  );
  const { locationGrainTrackerValues, locationSelectedIs, selectedLocation } =
    useSelector((state: State) => state.GrainWiseEditionReducer);

  const {
    locationSelectedDetails,
    isBinSelected,
    selectedBin,
    locationViewValues,
    resetStorageCapacity,
    isLocationShared,
    locationInfoFromTable,
  } = useSelector((state: State) => state.SingleLocationReducer);

  const { successShareDeleteBins } = useSelector(
    (state: State) => state.ShareSiteReducer,
  );

  const selectedBinValues = selectedBin?.values;
  const bodyModalLoading = BodyLoadingModal(
    locationViewValues.loading || selectedBin.loading,
  );

  const token = user?.token ?? "";
  const {
    fetchStoragesOfEachLocation,
    redirectToEditLocation,
    redirectToEditStorage,
    resetBin,
    resetStateShareSite,
    resetStorage,
    resetSingleLocationState,
    setSelectedSiteToShare,
    setInformationByClicking,
  } = SetActions();
  const { logoutClickHandler } = SetActionsLayout();

  useEffect(() => {
    fetchStoragesOfEachLocation(token, locationSelectedDetails?.id as number);
    CheckExpiredToken(logoutClickHandler, user);
    resetBin();
    setTimeout(() => {
      resetStateShareSite();
    }, 1200);
  }, []);

  const globalComponentsLocationDetails = () => {
    const totalUsersInlocation = locationSelectedDetails?.nbUsers ?? 0;
    const sharedLocation = locationSelectedDetails?.nbSharedAccess ?? 0;
    const capacity = locationSelectedDetails?.totalCapacity?.value;

    return locationSelectedDetails !== undefined ? (
      <div>
        <LocationDetailsMenu
          t={t}
          setInformationByClicking={setInformationByClicking}
          locationSelectedDetails={locationSelectedDetails}
          navigate={navigate}
          totalUsersInlocation={totalUsersInlocation}
          sharedLocation={sharedLocation}
          capacity={capacity as number}
          redirectToEditLocation={redirectToEditLocation}
          locationGrainTrackerValues={locationGrainTrackerValues}
          locationSelectedIs={locationSelectedIs}
          selectedLocation={selectedLocation}
          isBinSelected={isBinSelected}
          selectedBin={selectedBin}
          isLocationShared={isLocationShared}
          successShareDeleteBins={successShareDeleteBins}
          resetBin={resetBin}
          redirectToEditStorage={redirectToEditStorage}
          setSelectedSiteToShare={setSelectedSiteToShare}
          resetSingleLocationState={resetSingleLocationState}
          locationInfoFromTable={locationInfoFromTable}
        />
        {locationViewValues.storages.length >= 1 ? (
          <div>
            {!isBinSelected ? (
              <>
                <div>{errors(selectedBin.error)}</div>
                <div>{filters()}</div>
                <div className="bins-card-location">
                  {!locationViewValues.loading
                    ? BinCard(locationViewValues.storages, t)
                    : LoadingCircularProgress()}
                </div>
              </>
            ) : (
              <SelectedBin
                selectedBinValues={selectedBinValues}
                t={t}
                resetStorage={resetStorage}
                loading={selectedBin.loading}
                loadingResetStorageCapacity={resetStorageCapacity.loading}
                resetStorageCapacityError={resetStorageCapacity.error}
                isLocationShared={isLocationShared}
              />
            )}
          </div>
        ) : (
          <div className="no-storage-options-location">
            <div className="no-storage-options-location-text">
              {t("Grain_tracker.no_bin_one")}
            </div>
            <div className="no-storage-options-location-text mb-3">
              {t("Grain_tracker.no_bin_two")}
            </div>
            <Button
              sx={{ textTransform: "none" }}
              variant="contained"
              endIcon={<AddIcon />}
              onClick={() =>
                redirectToEditStorage(
                  locationSelectedDetails,
                  navigate,
                  locationSelectedIs,
                  locationGrainTrackerValues,
                )
              }
            >
              {t("Grain_tracker.add_new_stockage")}
            </Button>
          </div>
        )}
        <Modal
          open={locationViewValues.loading || false || selectedBin.loading}
        >
          {bodyModalLoading}
        </Modal>
        <Snackbar
          open={successShareDeleteBins}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity="success" variant="filled" sx={{ width: "100%" }}>
            {t("Fleet_users.alert.Saved_1")}
          </Alert>
        </Snackbar>
      </div>
    ) : (
      navigate("/locations")
    );
  };

  return (
    <Layout
      title={""}
      component={
        !isViewerOnly ? globalComponentsLocationDetails() : <NotFound />
      }
    />
  );
};

export default LocationDetails;
